/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
 import { AjaxError } from 'rxjs/ajax';
 import {
   AggregatedDataUsageRequestPayload,
   CumulativeUsageByNetwork,
   UsageByNetwork,
   DataUsageRequestPayload,
   UsageByLink,
   TotalUsageByNetwork,
   TotalUsageByLink,
   TotalPacketLossByLink,
   PacketLossByLink,
   ServiceAvailability,
 } from '../../shared/entities/dataUsage';
 import ActionCreator from '../action-creator';
 
 export const ActionCreators = {
   // Totals by network
   RequestTotalUsageByNetwork: new ActionCreator<'RequestTotalUsageByNetwork', DataUsageRequestPayload>(
     'RequestTotalUsageByNetwork',
   ),
   ReceivedTotalUsageByNetworkSuccess: new ActionCreator<'ReceivedTotalUsageByNetworkSuccess', TotalUsageByNetwork>(
     'ReceivedTotalUsageByNetworkSuccess',
   ),
   ReceivedTotalUsageByNetworkError: new ActionCreator<'ReceivedTotalUsageByNetworkError', AjaxError>(
     'ReceivedTotalUsageByNetworkError',
   ),
   ClearReceivedTotalUsageByNetworkError: new ActionCreator<'ClearReceivedTotalUsageByNetworkError', undefined>(
     'ClearReceivedTotalUsageByNetworkError',
   ),
 
   // Totals by link
   RequestTotalUsageByLink: new ActionCreator<'RequestTotalUsageByLink', DataUsageRequestPayload>(
     'RequestTotalUsageByLink',
   ),
   ReceivedTotalUsageByLinkSuccess: new ActionCreator<'ReceivedTotalUsageByLinkSuccess', TotalUsageByLink>(
     'ReceivedTotalUsageByLinkSuccess',
   ),
   ReceivedTotalUsageByLinkError: new ActionCreator<'ReceivedTotalUsageByLinkError', AjaxError>(
     'ReceivedTotalUsageByLinkError',
   ),
   ClearReceivedTotalUsageByLinkError: new ActionCreator<'ClearReceivedTotalUsageByLinkError', undefined>(
     'ClearReceivedTotalUsageByLinkError',
   ),
 
   // Usage by Link
   RequestUsageByLink: new ActionCreator<'RequestUsageByLink', AggregatedDataUsageRequestPayload>('RequestUsageByLink'),
   ReceivedUsageByLinkSuccess: new ActionCreator<'ReceivedUsageByLinkSuccess', UsageByLink>(
     'ReceivedUsageByLinkSuccess',
   ),
   ReceivedUsageByLinkError: new ActionCreator<'ReceivedUsageByLinkError', AjaxError>('ReceivedUsageByLinkError'),
   ClearReceivedUsageByLinkError: new ActionCreator<'ClearReceivedUsageByLinkError', undefined>(
     'ClearReceivedUsageByLinkError',
   ),
 
   // Usage by Link Cumulative
   RequestUsageByLinkCumulative: new ActionCreator<'RequestUsageByLinkCumulative', AggregatedDataUsageRequestPayload>(
     'RequestUsageByLinkCumulative',
   ),
   ReceivedUsageByLinkCumulativeSuccess: new ActionCreator<'ReceivedUsageByLinkCumulativeSuccess', UsageByLink>(
     'ReceivedUsageByLinkCumulativeSuccess',
   ),
   ReceivedUsageByLinkCumulativeError: new ActionCreator<'ReceivedUsageByLinkCumulativeError', AjaxError>(
     'ReceivedUsageByLinkCumulativeError',
   ),
   ClearReceivedUsageByLinkCumulativeError: new ActionCreator<'ClearReceivedUsageByLinkCumulativeError', undefined>(
     'ClearReceivedUsageByLinkCumulativeError',
   ),
 
   // Usage by network
   RequestUsageByNetwork: new ActionCreator<'RequestUsageByNetwork', AggregatedDataUsageRequestPayload>(
     'RequestUsageByNetwork',
   ),
   ReceivedUsageByNetworkSuccess: new ActionCreator<'ReceivedUsageByNetworkSuccess', UsageByNetwork>(
     'ReceivedUsageByNetworkSuccess',
   ),
   ReceivedUsageByNetworkError: new ActionCreator<'ReceivedUsageByNetworkError', AjaxError>(
     'ReceivedUsageByNetworkError',
   ),
   ClearReceivedUsageByNetworkError: new ActionCreator<'ClearReceivedUsageByNetworkError', undefined>(
     'ClearReceivedUsageByNetworkError',
   ),
 
   // Cumulative usage by network
   RequestCumulativeUsageByNetwork: new ActionCreator<'RequestCumulativeUsageByNetwork', DataUsageRequestPayload>(
     'RequestCumulativeUsageByNetwork',
   ),
   ReceivedCumulativeUsageByNetworkSuccess: new ActionCreator<
     'ReceivedCumulativeUsageByNetworkSuccess',
     CumulativeUsageByNetwork
   >('ReceivedCumulativeUsageByNetworkSuccess'),
   ReceivedCumulativeUsageByNetworkError: new ActionCreator<'ReceivedCumulativeUsageByNetworkError', AjaxError>(
     'ReceivedCumulativeUsageByNetworkError',
   ),
   ClearReceivedCumulativeUsageByNetworkError: new ActionCreator<
     'ClearReceivedCumulativeUsageByNetworkError',
     undefined
   >('ClearReceivedCumulativeUsageByNetworkError'),
 
   // Total Packet Loss
   RequestTotalPacketLossByLink: new ActionCreator<'RequestTotalPacketLossByLink', DataUsageRequestPayload>(
     'RequestTotalPacketLossByLink',
   ),
   ReceivedTotalPacketLossByLinkSuccess: new ActionCreator<'ReceivedTotalPacketLossByLinkSuccess', TotalPacketLossByLink>(
     'ReceivedTotalPacketLossByLinkSuccess',
   ),
   ReceivedTotalPacketLossByLinkError: new ActionCreator<'ReceivedTotalPacketLossByLinkError', AjaxError>(
     'ReceivedTotalPacketLossByLinkError',
   ),
   ClearReceivedTotalPacketLossByLinkError: new ActionCreator<'ClearReceivedTotalPacketLossByLinkError', undefined>(
     'ClearReceivedTotalPacketLossByLinkError',
   ),
 
   // Packet Loss
   RequestPacketLossByLink: new ActionCreator<'RequestPacketLossByLink', AggregatedDataUsageRequestPayload>(
     'RequestPacketLossByLink',
   ),
   ReceivedPacketLossByLinkSuccess: new ActionCreator<'ReceivedPacketLossByLinkSuccess', PacketLossByLink>(
     'ReceivedPacketLossByLinkSuccess',
   ),
   ReceivedPacketLossByLinkError: new ActionCreator<'ReceivedPacketLossByLinkError', AjaxError>(
     'ReceivedPacketLossByLinkError',
   ),
   ClearReceivedPacketLossByLinkError: new ActionCreator<'ClearReceivedPacketLossByLinkError', undefined>(
     'ClearReceivedPacketLossByLinkError',
   ),

   // Service Availability
   RequestServiceAvailability: new ActionCreator<'RequestServiceAvailability', AggregatedDataUsageRequestPayload>(
     'RequestServiceAvailability',
   ),
   ReceivedServiceAvailabilitySuccess: new ActionCreator<'ReceivedServiceAvailabilitySuccess', ServiceAvailability>(
     'ReceivedServiceAvailabilitySuccess',
   ),
   ReceivedServiceAvailabilityError: new ActionCreator<'ReceivedServiceAvailabilityError', AjaxError>(
     'ReceivedServiceAvailabilityError',
   ),
   ClearReceivedServiceAvailabilityError: new ActionCreator<'ClearReceivedServiceAvailabilityError', undefined>(
     'ClearReceivedServiceAvailabilityError',
   ), 
 
   ClearDataUsage: new ActionCreator<'ClearDataUsage', undefined>('ClearDataUsage'),
 };
 
 export type Action = typeof ActionCreators[keyof typeof ActionCreators];
 
 // Totals by network
 export function requestTotalUsageByNetwork(request: DataUsageRequestPayload) {
   return ActionCreators.RequestTotalUsageByNetwork.create(request);
 }
 export function receivedTotalUsageByNetworkSuccess(response: TotalUsageByNetwork) {
   return ActionCreators.ReceivedTotalUsageByNetworkSuccess.create(response);
 }
 export function receivedTotalUsageByNetworkError(error: AjaxError) {
   return ActionCreators.ReceivedTotalUsageByNetworkError.create(error);
 }
 export function clearReceivedTotalUsageByNetworkError() {
   return ActionCreators.ClearReceivedTotalUsageByNetworkError.create();
 }
 
 // Totals by link
 export function requestTotalUsageByLink(request: DataUsageRequestPayload) {
   return ActionCreators.RequestTotalUsageByLink.create(request);
 }
 export function receivedTotalUsageByLinkSuccess(response: TotalUsageByLink) {
   return ActionCreators.ReceivedTotalUsageByLinkSuccess.create(response);
 }
 export function receivedTotalUsageByLinkError(error: AjaxError) {
   return ActionCreators.ReceivedTotalUsageByLinkError.create(error);
 }
 export function clearReceivedTotalUsageByLinkError() {
   return ActionCreators.ClearReceivedTotalUsageByLinkError.create();
 }
 
 //  usage by Link
 export function requestUsageByLink(request: AggregatedDataUsageRequestPayload) {
   return ActionCreators.RequestUsageByLink.create(request);
 }
 export function receivedUsageByLinkSuccess(response: UsageByLink) {
   return ActionCreators.ReceivedUsageByLinkSuccess.create(response);
 }
 export function receivedUsageByLinkError(error: AjaxError) {
   return ActionCreators.ReceivedUsageByLinkError.create(error);
 }
 export function clearReceivedUsageByLinkError() {
   return ActionCreators.ClearReceivedUsageByLinkError.create();
 }
 
 //  usage by Link cumulative
 export function requestUsageByLinkCumulative(request: AggregatedDataUsageRequestPayload) {
   return ActionCreators.RequestUsageByLinkCumulative.create(request);
 }
 export function receivedUsageByLinkCumulativeSuccess(response: UsageByLink) {
   return ActionCreators.ReceivedUsageByLinkCumulativeSuccess.create(response);
 }
 export function receivedUsageByLinkCumulativeError(error: AjaxError) {
   return ActionCreators.ReceivedUsageByLinkCumulativeError.create(error);
 }
 export function clearReceivedUsageByLinkCumulativeError() {
   return ActionCreators.ClearReceivedUsageByLinkCumulativeError.create();
 }
 
 //  usage by network
 export function requestUsageByNetwork(request: AggregatedDataUsageRequestPayload) {
   return ActionCreators.RequestUsageByNetwork.create(request);
 }
 export function receivedUsageByNetworkSuccess(response: UsageByNetwork) {
   return ActionCreators.ReceivedUsageByNetworkSuccess.create(response);
 }
 export function receivedUsageByNetworkError(error: AjaxError) {
   return ActionCreators.ReceivedUsageByNetworkError.create(error);
 }
 export function clearReceivedUsageByNetworkError() {
   return ActionCreators.ClearReceivedUsageByNetworkError.create();
 }
 
 //  cumulative usage by network
 export function requestCumulativeUsageByNetwork(request: AggregatedDataUsageRequestPayload) {
   return ActionCreators.RequestCumulativeUsageByNetwork.create(request);
 }
 export function receivedCumulativeUsageByNetworkSuccess(response: CumulativeUsageByNetwork) {
   return ActionCreators.ReceivedCumulativeUsageByNetworkSuccess.create(response);
 }
 export function receivedCumulativeUsageByNetworkError(error: AjaxError) {
   return ActionCreators.ReceivedCumulativeUsageByNetworkError.create(error);
 }
 export function clearReceivedCumulativeUsageByNetworkError() {
   return ActionCreators.ClearReceivedCumulativeUsageByNetworkError.create();
 }
 
 // total packet loss
 export function requestTotalPacketLossByLink(request: DataUsageRequestPayload) {
   return ActionCreators.RequestTotalPacketLossByLink.create(request);
 }
 export function receivedTotalPacketLossByLinkSuccess(response: TotalPacketLossByLink) {
   return ActionCreators.ReceivedTotalPacketLossByLinkSuccess.create(response);
 }
 export function receivedTotalPacketLossByLinkError(error: AjaxError) {
   return ActionCreators.ReceivedTotalPacketLossByLinkError.create(error);
 }
 export function clearReceivedTotalPacketLossByLinkError() {
   return ActionCreators.ClearReceivedTotalPacketLossByLinkError.create();
 }
 
 // packet loss
 export function requestPacketLossByLink(request: AggregatedDataUsageRequestPayload) {
   return ActionCreators.RequestPacketLossByLink.create(request);
 }
 export function receivedPacketLossByLinkSuccess(response: PacketLossByLink) {
   return ActionCreators.ReceivedPacketLossByLinkSuccess.create(response);
 }
 export function receivedPacketLossByLinkError(error: AjaxError) {
   return ActionCreators.ReceivedPacketLossByLinkError.create(error);
 }
 export function clearReceivedPacketLossByLinkError() {
   return ActionCreators.ClearReceivedPacketLossByLinkError.create();
 }

 // service availability
 export function requestServiceAvailability(request: AggregatedDataUsageRequestPayload) {
  return ActionCreators.RequestServiceAvailability.create(request);
}
export function receivedServiceAvailabilitySuccess(response: ServiceAvailability) {
  return ActionCreators.ReceivedServiceAvailabilitySuccess.create(response);
}
export function receivedServiceAvailabilityError(error: AjaxError) {
  return ActionCreators.ReceivedServiceAvailabilityError.create(error);
}
export function clearReceivedServiceAvailabilityError() {
  return ActionCreators.ClearReceivedServiceAvailabilityError.create();
}
 
 export function clearDataUsage() {
   return ActionCreators.ClearDataUsage.create();
 }